// @flow
export const TRIP_INFORMATION_UPDATE_PARTICIPANTS_LAST_NAME =
  'TRIP_INFORMATION_UPDATE_PARTICIPANTS_LAST_NAME';

function setParticipantsLastNameWithMainContacts(
  userInfos: UserInfo,
  adultCount: Number,
  kidCount: Number,
) {
  return {
    type: TRIP_INFORMATION_UPDATE_PARTICIPANTS_LAST_NAME,
    payload: {
      userInfos,
      adultCount,
      kidCount,
    },
  };
}

export { setParticipantsLastNameWithMainContacts };
